import { RESET_FILTER_REQUEST_TRADER } from "../../domains/filter/store/actions";
import { RESET_RFP_FILTER_REQUEST_TRADER } from "../../domains/rfp/store/actions";
import { IsJsonString } from "../utils/validator";
import { SET_CURRENCIES, SET_CURRENCY } from "./actions"

export default {
    state: {
        currency: localStorage.getItem("currency") ? (JSON.parse(localStorage.getItem("currency"))) : null,
        currencies: [],
        currenciesIds: [],
    },
    getters: {
        currency: state => state.currency,
        currencies: state => state.currencies,
        currenciesIds: state => state.currenciesIds,
    },
    actions: {
        [SET_CURRENCY]: ({ commit }, currency) => {
            return new Promise((resolve, reject) => {
                localStorage.setItem("currency", JSON.stringify(currency));

                commit(SET_CURRENCY, currency);
                commit(RESET_FILTER_REQUEST_TRADER);
                commit(RESET_RFP_FILTER_REQUEST_TRADER)
                resolve();
            })

        },
    },
    mutations: {
        [SET_CURRENCY]: (state, currency) => {
            state.currency = currency;
        },
        [SET_CURRENCIES]: (state, currencies) => {
            state.currencies = currencies;
            var obj = {};
            currencies.forEach(function(item) {
                obj[item.id] = item;
            })
            state.currenciesIds = obj
        },

    }
};